module.exports = __webpack_public_path__ + "img/in_game.98b2b9ee.png";